import styled from "styled-components"
import { device } from "breakpoints"

import { getGradient } from "helpers/getGradient"
import { getSolidColor } from "helpers/getSolidColor"

import { Teaser } from "../Teaser"
import { Title, Excerpt, InfoWrapper, ImageWrapper } from "../Teaser/style"
import AvenueLink from "components/AvenueLink"

export const CTAButton = styled(AvenueLink)`
  display: ${props => (props.show ? "block" : "none")};
  font-weight: 600;
  font-size: 16px;
  color: #ffffff !important;
  letter-spacing: -0.12px;
  text-align: center;
  line-height: 24px;

  border: 2px solid #ffffff;
  border-radius: 24.5px;
  padding: 9px;
  margin-top: 4px;
  margin-bottom: 6px;
  width: 100%;
  max-width: 180px;

  @media ${device.tablet} {
    font-size: 20px;
    letter-spacing: -0.16px;
    text-align: center;
    line-height: 24px;
    margin: 0;
    margin-top: 15px;
    padding: 9px 27px;
    max-width: 177px;
  }
`
export const CustomCTATeaser = styled(Teaser)`
  margin-bottom: 50px;

  cursor: ${props => (props.show ? "pointer" : "default")};

  @media ${device.tablet} {
    flex-direction: ${props =>
      props.reverse === "right" ? "row-reverse" : "row"};
  }
  @media ${device.desktop} {
    margin-top: 3px;
  }
  /* padding-right: 55px; */

  :hover {
    ${Title} {
      color: #fff;
    }
    ${CTAButton} {
      background-color: ${props => getSolidColor(props.theme.site)};
    }
  }

  ${Title} {
    font-weight: 700;
    font-size: 20px;
    color: #ffffff;
    letter-spacing: -0.21px;
    line-height: 22px;
    text-transform: uppercase;
    margin-bottom: 9px;

    @media ${device.tablet} {
      font-size: 24px;
      letter-spacing: -0.25px;
      line-height: 24px;
      margin-bottom: 20px;
    }
  }
  ${Excerpt} {
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    letter-spacing: -0.12px;
    line-height: 22px;
    @media ${device.tablet} {
      font-size: 20px;
      letter-spacing: -0.16px;
      line-height: 24px;
    }
  }

  ${ImageWrapper} {
    margin-bottom: 0;
    padding-top: 72.7%;
    @media ${device.tablet} {
      padding-top: 33.5%;
      max-width: 50%;
    }
    @media ${device.desktop} {
      padding-top: 42.5%;
    }
  }

  ${InfoWrapper} {
    background-image: ${props => getGradient(props.theme.site)};
    padding: 20px 28px;
    @media ${device.tablet} {
      max-width: 50%;
      padding: 45px 39px;
      display: flex;
      justify-content: center;
      height: auto;
    }
  }
`
